import { createElement } from 'react';
const Text = (props) => {
    const { text, ...others } = props;
    return (createElement("div", Object.assign({}, others), text));
};
export default Text;
